import React from "react"

export const MANAGE_CENTER_COLUMNS = [
  {
    Header: "MOC ID",
    accessor: "mocCenterId",
  },
  {
    Header: "Name",
    accessor: "centerName",
  },
  {
    Header: "Address",
    accessor: "address.addressLine1",
  },
  {
    Header: "Suburb",
    accessor: "address.suburb",
  },
  {
    Header: "Contact number",
    accessor: "contactNumber",
  },
  {
    Header: "Email",
    accessor: "email",
  },
  {
    Header: "",
    accessor: "Edit",
    Cell: () => (
      <img
        className="eye-icon"
        src={"assets/images/CRedit.svg"}
        width={32}
        height={30}
        style={{
          marginTop: "6px",
          paddingRight: "15px",
          width: "40px",
          height: "40px",
        }}
        alt="eye"
      />
    ),
  },
]
